import React from 'react'
import './spinner.scss'

function LoadingSpinner() {
  return <div className="lds-dual-ring" />
}

export default LoadingSpinner
